// extracted by mini-css-extract-plugin
module.exports = {"coupleInfoContainer":"CoupleInfoBox_coupleInfoContainer__1xHsA","contactDetailsWrapper":"CoupleInfoBox_contactDetailsWrapper__1CQvD"};